interface PlaceholderPageProps {
  title: string
  /** Roadmap phase that delivers this screen — see docs/04-delivery/roadmap.md. */
  phase: number
}

export function PlaceholderPage({ title, phase }: PlaceholderPageProps) {
  return (
    <div className="max-w-xl">
      <h1 className="text-ink-900 text-2xl font-semibold">{title}</h1>
      <p className="text-ink-700 mt-2 text-sm">
        {phase > 0
          ? `Scheduled for phase ${phase} of the delivery roadmap.`
          : 'This page does not exist.'}
      </p>
    </div>
  )
}
